import React, { ReactNode } from 'react';
import cx from 'classnames';
import { Flags } from 'react-feature-flags';
import { SecondaryButton } from '@JohnLewisPartnership/jl-design-system/dist/elements/button/Button';
import { WishlistFilled } from '@JohnLewisPartnership/jl-design-system/dist/components/icons/WishlistFilled';
import { WishlistOutlined } from '@JohnLewisPartnership/jl-design-system/dist/components/icons/WishlistOutlined';
import styles from './AddToWishListButton.module.scss';
import { FEATURE_FLAGS } from '../../helpers/featureFlags/constants';
import { redirectToSignIn } from '../../helpers/redirect/redirect';
import Cookies from 'js-cookie';
import { isFlagSet } from '../../helpers/featureFlags/featureFlags';

export interface AddToWishListButtonProps {
    handleWishListOnClick?: (wishListId: string) => Promise<void>;
    isAdded?: boolean;
    isExpanded?: boolean;
    isSubmitting?: boolean;
    productId: string;
}

export const AddToWishListButton: React.FC<AddToWishListButtonProps> = ({
    handleWishListOnClick,
    isAdded = false,
    isExpanded = false,
    isSubmitting = false,
    productId,
}: AddToWishListButtonProps) => {
    const wishListIcon = isAdded ? <WishlistFilled /> : <WishlistOutlined />;
    const buttonText = getButtonText(isAdded);

    return (
        <SecondaryButton
            data-testid="add-to-wish-list-button"
            onClick={(): Promise<void> | undefined => {
                if (!Cookies.get('shopperId') && !isFlagSet(FEATURE_FLAGS.GUEST_WISHLIST)) {
                    // Guest user
                    redirectToSignIn(productId, 'button');
                    return;
                } else {
                    return handleWishListOnClick?.('');
                }
            }}
            className={cx(styles.addToWishListButton, {
                [styles.wishListExpanded]: isExpanded,
            })}
            submitting={isSubmitting}
        >
            <div className={styles.wishListButtonContent}>
                {wishListIcon}
                <div>{buttonText}</div>
            </div>
        </SecondaryButton>
    );
};

const getButtonText = (isAdded: boolean): JSX.Element => (
    <Flags
        authorizedFlags={[FEATURE_FLAGS.NURSERY_PROTOTYPE]}
        renderOn={(): ReactNode => <>{isAdded ? 'Added to baby wish list' : 'Add to baby wish list'}</>}
        renderOff={(): ReactNode => <>{isAdded ? 'Added to wish list' : 'Add to wish list'}</>}
    />
);

export default AddToWishListButton;
